// extracted by mini-css-extract-plugin
export var displayNone = "_ra-6";
export var imgContainer = "_ra-2";
export var overflowHidden = "_ra-3";
export var productInfoCardButtonContainer = "_ra-5";
export var productTitleText = "_ra-4";
export var rightArrow = "_ra-1";
export var rightArrowContainer = "_ra-0";